import { Directive, Input, ElementRef, HostListener, OnInit } from '@angular/core';
import { NODE_MAP } from './node-map';

@Directive({ selector: '[treeDrag]',
  standalone: false })
export class TreeDragDirective implements OnInit {
  @Input('treeDrag') node: any;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit() {
    if (this.node) {
      NODE_MAP.set(this.el.nativeElement, this.node);
      this.el.nativeElement.setAttribute('draggable', 'true');
    }
  }

  @HostListener('dragstart', ['$event']) onDragStart(ev: DragEvent) {
    try {
      if (ev.dataTransfer) ev.dataTransfer.setData('text/plain', 'ecpl-node');
      // attach node ref to event
      (ev as any).__ecpl_node = this.node;
    } catch (e) {}
  }
}
